import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  PageHeader,
  VerticalTabsLayout,
  useTreeData,
  CapabilityNav,
} from "@velocity-ehs/component-library";
import { UsersAssignedToRoleList } from "./UsersAssignedToRoleList";
import { useGetUsersAssignedToRole } from "../../../../hooks/useGetUsersAssignedToRole";
import { SortDirection } from "../../../supportFunctions/graphql/Queries";
import { useState } from "react";
import { navItems } from "../NavHelpers";
import { useFlags } from "launchdarkly-react-client-sdk";
import { ExplicitAssignedOptions } from "../Utils";

const defaultParams = {
  first: 0,
  rows: 20,
  page: 0,
  sortField: "displayName",
  sortOrder: SortDirection.ASC,
  filters: {
    displayName: {
      value: null,
    },
    isExplicitlyAssigned: {
      value: [ExplicitAssignedOptions[0]],
    },
    userStatus: {
      value: [],
    },
  },
};

const UsersAssignedToRole = () => {
  const { t } = useTranslation();
  const allFlags = useFlags();
  const [lazyParams, setLazyParams] = useState(defaultParams);
  const history = useHistory();
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const roleName = urlSearchParams.get("roleName");
  const locationID = urlSearchParams.get("locationID");
  const match = useRouteMatch<{ id: string }>();
  const treeData = useTreeData();

  const roleLocation = treeData?.treeStore.active?.flatTree.find(
    (location: { id: string | null }) => location.id === locationID
  );

  const { usersAssignedToRole, pagination, isFetching } =
    useGetUsersAssignedToRole(match.params.id, lazyParams, { id: locationID });

  const tabs = [
    {
      title: t("universal_Users"),
      content: (
        <UsersAssignedToRoleList
          users={usersAssignedToRole}
          lazyParams={lazyParams}
          setLazyParams={setLazyParams}
          pagination={pagination}
          isLoading={!treeData.isAllFetched || isFetching}
          roleLocation={locationID}
          roleId={match.params.id}
        />
      ),
    },
  ];

  return (
    <div className="App">
      <CapabilityNav
        capability="Roles Management"
        navItems={navItems()}
        featureFlags={allFlags}
      />
      <div className="mainContent">
        <PageHeader
          title={usersAssignedToRole?.[0]?.roleName || roleName}
          navigationTree={[
            { text: `Accelerate ${t("universal_Home")}`, href: "/" },
            {
              text: t("universal_assignment_by_location"),
              href: "/role-management/location-roles",
            },
            { text: t("universal_Users"), href: "" },
          ]}
          subtitle={roleLocation?.lineage || roleLocation?.label}
        />
        <VerticalTabsLayout
          tabs={tabs}
          pathname={match.url}
          routeMatch={match}
          toRoute={history.push}
        />
      </div>
    </div>
  );
};

export default UsersAssignedToRole;
